import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { ErrorBannerService } from '../services/error-banner.service';
import { AppErrorService } from '../services/app-error.service';
import { SystemToastService } from '../services/system-toast.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private static readonly AUTH_LOGOUT_DELAY_MS = 1100;

  constructor(private injector: Injector, private authService: AuthService) {}

  handleError(error: any): void {
    const errorBanner = this.injector.get(ErrorBannerService);
    const appError = this.injector.get(AppErrorService);
    console.error(error);

    const resolved = appError.resolve(error);
    const isPostLoginContext = this.authService.isAuthenticated();

    if (!isPostLoginContext) {
      return;
    }

    if (appError.shouldForceLogoutByCode(resolved.code, resolved.rawMessage)) {
      const systemToast = this.injector.get(SystemToastService);
      systemToast.show({
        title: 'Error',
        message: resolved.message,
      });
      setTimeout(() => {
        this.authService.forceLogout();
      }, GlobalErrorHandler.AUTH_LOGOUT_DELAY_MS);
      return;
    }

    if (resolved.message) {
      errorBanner.show(resolved.message);
    }
  }
}
